namespace advisorop.components.advisor {

    export class SelectCuAccountBeneficiariesController {
        
        account: domains.IAccount;

        accountBeneficiary: domains.IAccountBeneficiary = { investor: {}, accountId: 0, recordStatus: domains.RecordStatus.ACTIVE };
        accountBeneficiaries: domains.IAccountBeneficiary[] = [];
        removedAccountBeneficiaries: domains.IAccountBeneficiary[] = [];

        beneficiariesAreDirty: boolean = false;

        lovs: domains.ILOV[] = [];
        beneficiaryTypes: domains.ILOV[] = [];

        investorType: domains.InvestorType = domains.InvestorType.INDIVIDUAL;
        entityType: domains.EntityType = null;

        relationTypes: domains.ILOV[] = [];
        individualTypes: domains.ILOV[] = [];
        individualType: domains.ILOV = {};
        relationshipType: domains.ILOV = {};
        beneficiaryType: domains.ILOV = {};
        gender: domains.ILOV = {};
        countryCitizenIncorp: domains.ILOV = {};

        individualTypeIndividual: domains.IndividualType = domains.IndividualType.INDIVIDUAL;
        individualTypeEntity: domains.IndividualType = domains.IndividualType.ENTITY;
        
        selInvestor: domains.IInvestor;

        genders: domains.ILOV[] = [];
        countries: domains.ILOV[] = [];
        usCountryCode: string = "US";

        selectedInvestor: domains.IInvestor = {};

        dgBeneficiaries: DevExpress.ui.dxDataGridOptions;

        sumPrimary: number = 0;
        sumContingent: number = 0;

        accountId: number;
        beneficiariesChange: any;
        beneficiariesComplete: any;

        allowChanges: boolean = true;
        iAmReady: any;
        
        // Force this to false for now until we improve our Links capability (relationships between investors)
        selectFromExistingInvestors: boolean = false;

        savingBensLadda: boolean = false;

        static $inject = ["generalService", "advisorService", "$scope", "accountApi"];
        constructor(private generalService: services.GeneralService,
            private advisorService: services.AdvisorService,
            private $scope: ng.IScope,
            private accountApi: services.AccountApi
        ) {
            this.dgBeneficiaries = {
                export: {
                    enabled: true,
                    fileName: "AccountBeneficiaries"
                },
                bindingOptions: {
                    dataSource: "vm.accountBeneficiaries"
                },
                paging: { pageSize: 20 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                noDataText: "No Beneficiaries added",                
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },                
                wordWrapEnabled: true,
                columns: [
                    { dataField: "beneficiaryTypeLov.name", caption: "Beneficiary type", visible: true },
                    { dataField: "percentAllocation", caption: "Percent Allocation", visible: true },
                    {
                        dataField: "id", caption: "Investor", width: 120, visible: true, cellTemplate: "investorData"
                    },
                    {
                        dataField: "id", caption: "New Beneficiary", width: 120, visible: true, cellTemplate: "newBenData"
                    },
                    { dataField: "relationTypeLov.name", caption: "Relation Type", visible: true },                    
                    { dataField: "individualTypeLov.name", caption: "Individual Type", visible: true },                    
                    { dataField: "id", caption: "#", cellTemplate: "btnActions", width: 100 }
                ],
            };

            $scope.$watch("vm.accountBeneficiary.beneficiaryTypeLov", () => {
                if (this.accountBeneficiary != undefined && this.accountBeneficiary.beneficiaryTypeLov != undefined && this.accountBeneficiary.beneficiaryTypeLov.id != undefined)
                {
                    if (this.accountBeneficiary.beneficiaryTypeLov.id != null) {
                        this.accountBeneficiary.beneficiaryType = this.accountBeneficiary.beneficiaryTypeLov.value;
                    } else {
                        this.accountBeneficiary.beneficiaryType = null;
                    }
                }
            });

            $scope.$watch("vm.accountBeneficiary.genderLov", () => {
                if (this.accountBeneficiary != undefined && this.accountBeneficiary.genderLov != undefined && this.accountBeneficiary.genderLov.id != undefined) {
                    if (this.accountBeneficiary.genderLov.id != null) {
                        this.accountBeneficiary.gender = this.accountBeneficiary.genderLov.value;
                    } else {
                        this.accountBeneficiary.gender = null;
                    }
                }
            });

            $scope.$watch("vm.accountBeneficiary.countryCitizenIncorpLov", () => {
                if (this.accountBeneficiary != undefined && this.accountBeneficiary.countryCitizenIncorpLov != undefined && this.accountBeneficiary.countryCitizenIncorpLov.id != undefined) {
                    if (this.accountBeneficiary.countryCitizenIncorpLov.id != null) {
                        this.accountBeneficiary.countryCitizenIncorp = this.accountBeneficiary.countryCitizenIncorpLov.extra2;
                    } else {
                        this.accountBeneficiary.countryCitizenIncorp = null;
                    }
                }
            });

            $scope.$watch("vm.accountBeneficiary.relationTypeLov", () => {
                if (this.accountBeneficiary != undefined && this.accountBeneficiary.relationTypeLov != undefined && this.accountBeneficiary.relationTypeLov.id != undefined) {
                    if (this.accountBeneficiary.relationTypeLov.id != null) {
                        this.accountBeneficiary.relationshipType = this.accountBeneficiary.relationTypeLov.value;
                    } else {
                        this.accountBeneficiary.relationshipType = null;
                    }
                }
            });

            $scope.$watch("vm.accountBeneficiary.individualTypeLov", () => {                
                if (this.accountBeneficiary != undefined && this.accountBeneficiary.individualTypeLov != undefined && this.accountBeneficiary.individualTypeLov.id != undefined) {
                    //console.log("this.accountBeneficiary", this.accountBeneficiary);
                    //console.log("this.accountBeneficiary.individualTypeLov", this.accountBeneficiary.individualTypeLov);
                    //console.log("this.accountBeneficiary.individualTypeLov.id", this.accountBeneficiary.individualTypeLov.id);
                    if (this.accountBeneficiary.individualTypeLov.id != null) {
                        this.accountBeneficiary.individualType = this.accountBeneficiary.individualTypeLov.value;
                        if (this.accountBeneficiary.individualType == domains.IndividualType.ENTITY) {
                            this.accountBeneficiary.relationshipType = domains.RelationshipType.OE;
                        }
                    } else {
                        this.accountBeneficiary.individualType = null;
                    }
                    //console.log("this.accountBeneficiary.individualType", this.accountBeneficiary.individualType);
                }
            });

            $scope.$watch("vm.selectedInvestor.id", () => {                
                if (this.selectedInvestor != undefined && this.accountBeneficiary != undefined) {
                    if (this.selectedInvestor.id != null) {
                        //console.log("Investor", this.selectedInvestor);
                        angular.copy(this.selectedInvestor, this.accountBeneficiary.investor);
                        this.accountBeneficiary.investorId = this.selectedInvestor.id;
                    } else {
                        
                    }
                }
            });
        }

        newInvestorSelected(investor: domains.IInvestor): void {
            //console.log("Investor:", investor);            
        };

        $onInit() : void {
            this.loadLovs();
            //console.log("ACCOUNT ID:", this.account.id);
            //console.log("allow changes", this.allowChanges);
            this.accountBeneficiary.accountId = this.account.id;
            this.loadAccountBeneficiaries();
            if (this.iAmReady) {
                this.iAmReady({ ctrl: this });
            }
        }

        loadAccountBeneficiaries() : void {
            if (this.account.id > 0) {
                this.accountApi.getBeneficiaries(this.account.id).then(data => {
                    this.accountBeneficiaries = data.data;
                    this.account.accountBeneficiaries = data.data;
                    this.beneficiariesAreDirty = false;
                    let primaries = this.accountBeneficiaries.filter(v => v.beneficiaryType == domains.BeneficiaryType.PRIMARY);
                    if (primaries.length > 0) {
                        // whether we are loading or saving we callback to caller when we have a valid set of primary beneficiaries
                        this.beneficiariesComplete();
                    }
                }, reason => {
                    toastr.error("Unable to load account beneficiaries: ", reason);
                })
            }
        }

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {

                    this.lovs = data;
                    this.beneficiaryTypes = this.lovs.filter(v => v.lovType == domains.LovType.BENEFICIARY_TYPE);
                    this.relationTypes = this.lovs.filter(v => v.lovType == domains.LovType.RELATIONSHIP_TYPE);
                    this.individualTypes = this.lovs.filter(v => v.lovType == domains.LovType.INDIVIDUAL_TYPE);
                    this.genders = this.lovs.filter(v => v.lovType == domains.LovType.GENDER);
                    this.countries = this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 === this.usCountryCode)
                        .concat(this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 !== this.usCountryCode));
                }, (reason) => {
                    toastr.error("Error " + reason);
                });
        };

        search(searchTerm: string): ng.IPromise<{}> {
            const iType: domains.InvestorType = null;
            const eType: domains.EntityType = null;
            return this.advisorService.searchInvestors(searchTerm, iType, eType).then((response) => {
                return response.data;
            });
        };

        onSelect(item, model, label, event): void {
            if (this.accountBeneficiaries.filter(v => v.investorId == item.id).length > 0) {
                toastr.warning("Account beneficiaries for this account are already defined for selected investor.");
            }
            else {
                angular.copy(item, this.selectedInvestor);
                this.BindSelectedInvestorToForm();
            }
            //this.accountBeneficiary.investorId = item.id;
            this.resetSearch();
        };

        resetSearch(): void {
            this.selInvestor = null;
        };

        removeSelectedInvestor() {
            this.selectedInvestor = {};
            this.accountBeneficiary.investor = {};
            this.accountBeneficiary.investorId = null;
        }

        checkIfInvestorIsSelected(): boolean {
            if (!this.selectFromExistingInvestors) {//return true because no investor is required
                return true;
            } else {//check if investor is selected
                return this.selectedInvestor != null && this.selectedInvestor.id != undefined;
            }
        }

        DOBorTin(): boolean {
            if (this.accountBeneficiary.individualType == this.individualTypeEntity) {
                return true;
            }
            var ret = false;
            if (this.accountBeneficiary.tin) {
                ret = true;
            }
            return (this.accountBeneficiary.dateOfBirth != undefined) || ret;
        };

        BindSelectedInvestorToForm() {
            this.accountBeneficiary.individualTypeLov = this.lovs.filter(v => v.lovType == domains.LovType.INDIVIDUAL_TYPE && v.value == this.selInvestor.investorType)[0];
            this.accountBeneficiary.firstName = this.selInvestor.firstName;
            this.accountBeneficiary.lastName = this.selInvestor.lastName;
            this.accountBeneficiary.entityName = this.selInvestor.entityName;
            this.accountBeneficiary.genderLov = this.lovs.filter(v => v.lovType == domains.LovType.GENDER && v.value == this.selInvestor.gender)[0];
            this.accountBeneficiary.dateOfBirth = this.selInvestor.dateOfBirth;
            this.accountBeneficiary.countryCitizenIncorpLov = this.lovs.filter(v => v.lovType == domains.LovType.COUNTRIES && v.extra2 == this.selInvestor.citizenship)[0];
            this.accountBeneficiary.tin = this.selInvestor.tin;
        }

        validateForm(): boolean {
            if (!this.checkIfInvestorIsSelected()) {
                toastr.warning("Select investor!");
                return false;
            }
            this.sumContingent = this.sumPrimary = 0;
            var toastrMsg = "";
            var formIsValid = true;
            //let primaryPercentageSum = this.accountBeneficiaries.filter(v => v.beneficiaryType == domains.BeneficiaryType.CONTINGENT).reduce(function (a, b) { console.log(a); }, 0)
            this.accountBeneficiaries.forEach((item, index) => {
                if (item.beneficiaryType == domains.BeneficiaryType.CONTINGENT)
                    this.sumContingent += item.percentAllocation;
                else
                    this.sumPrimary += item.percentAllocation;
            });

            if (this.accountBeneficiary.beneficiaryType == domains.BeneficiaryType.CONTINGENT && this.sumContingent + this.accountBeneficiary.percentAllocation > 100)
            {
                toastrMsg += ("Percent allocation for contingent beneficiary type would be greather then 100, please reduce percent allocation. Current sum is " + this.sumContingent + ". ");
                formIsValid = false;
//                toastr.warning("Percent allocation for contingent beneficiary type would be greather then 100, please reduce percent allocation. Current sum is " + this.sumContingent);
//                return false;
            }
            if (this.accountBeneficiary.beneficiaryType == domains.BeneficiaryType.PRIMARY && this.sumPrimary + this.accountBeneficiary.percentAllocation > 100) {
                toastrMsg += ("Percent allocation for primary beneficiary type would be greather then 100, please reduce percent allocation. Current sum is " + this.sumPrimary + ".");
                formIsValid = false;
//                toastr.warning("Percent allocation for primary beneficiary type would be greather then 100, please reduce percent allocation. Current sum is " + this.sumPrimary);
//                return false;
            }
            if (!this.DOBorTin()) {
                toastrMsg += ("A date of birth or TIN/SSL is required.");
                formIsValid = false;
            }

            if (!formIsValid) {
                toastr.warning(toastrMsg);
                return formIsValid;
            }

            formIsValid = this.generalService.validateForm(<ng.IFormController>this.$scope["frmBeneficiary"]);
            if (!formIsValid) {
                toastr.warning("Form is not valid!");
                return false;
            }

            return true;
        }

       resetForm(): void {
            this.selectedInvestor = {};
            this.gender = {};
            this.countryCitizenIncorp = {};
            this.relationshipType = {};
            this.individualType = {};
            this.beneficiaryType = {};

            this.accountBeneficiary = { investor: {}, accountId: this.account.id, recordStatus: domains.RecordStatus.ACTIVE };

            <ng.IFormController>this.$scope["frmBeneficiary"].$setUntouched();
        }

        setModel() {
            this.accountBeneficiary.id = 0;
            this.accountBeneficiary.accountId = this.account.id;
            //this.accountBeneficiary.beneficiaryType = this.beneficiaryType.value;

            if (this.checkIfInvestorIsSelected) {
                angular.copy(this.selectedInvestor, this.accountBeneficiary.investor);
                this.accountBeneficiary.investorId = this.selectedInvestor.id;
            }
            
            //else {
            //    this.accountBeneficiary.gender = this.gender.value;
            //    this.accountBeneficiary.individualType = this.individualType.value;
            //    this.accountBeneficiary.relationshipType = this.relationshipType.value;
            //}
            //console.log("model to add:", this.accountBeneficiary);
        }

        addBeneficiary(): void {
            if (this.validateForm()) {      
                //console.log("model to add:", this.accountBeneficiary);
                this.setModel();
                this.accountBeneficiaries.push(this.accountBeneficiary);
                toastr.info("Successfully added beneficiary to list");
                this.beneficiariesAreDirty = true;
                //this.beneficiariesChange();
                this.resetForm();
            }
        }

        removeBeneficiary(data: domains.IAccountBeneficiary) {
            var index = this.accountBeneficiaries.indexOf(data);

            if (data.id > 0) {
                data.recordStatus = domains.RecordStatus.DELETED;
                this.removedAccountBeneficiaries.push(data);
            }     
            
            this.accountBeneficiaries.splice(index, 1);
            this.beneficiariesAreDirty = true;
            //this.beneficiariesChange();
        }

        saveChanges(): void {
            this.savingBensLadda = true;
            let sumContingent = 0;
            let contingentCount = 0;
            let sumPrimary = 0;
            let primaryCount = 0;
            this.accountBeneficiaries.forEach((item, index) => {
                if (item.beneficiaryType == domains.BeneficiaryType.CONTINGENT) {
                    sumContingent += item.percentAllocation;
                    contingentCount += 1;
                }
                else {
                    sumPrimary += item.percentAllocation;
                    primaryCount += 1;
                }
            });

            //Contingent are not required so sum can be 0.
            //Primary are required.
            if (contingentCount > 0 && sumContingent != 100) {
                toastr.warning("Percentage sum of contingent account beneficiaries is " + sumContingent + ". The sum should be 100%. Please correct contingent account beneficiaries.");
                this.savingBensLadda = false;
                return;
            }
            if (primaryCount > 0 && sumPrimary != 100) {
                toastr.warning("Percentage sum of primary account beneficiaries is " + sumPrimary + ". The sum should be 100%. Please correct primary account beneficiaries.");
                this.savingBensLadda = false;
                return;
            }

            var beneficiariesToSave = this.accountBeneficiaries.concat(this.removedAccountBeneficiaries);
            //console.log("beneficiariesToSave: ", beneficiariesToSave);

            this.advisorService.saveAccountBeneficiaries(beneficiariesToSave).then(data => {
                toastr.success("You have successfuly saved account beneficiary changes.");
                this.removedAccountBeneficiaries = [];
                this.loadAccountBeneficiaries();
            }, (reason) => {
                toastr.error("Unable to save account beneficiaries: " + reason);
                }).finally(() => {
                    this.savingBensLadda = false;
                    this.beneficiariesChange();
                });
        }
        
    }

    class SelectCuAccountBeneficiaries implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                account: "<",
                beneficiariesChange: "&",
                beneficiariesComplete: "&",
                allowChanges: "<",
                iAmReady: "&"
            };
            this.controller = SelectCuAccountBeneficiariesController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/select-cu-account-beneficiaries.html";
        }
    }
    angular.module(Constants.APP).component("selectCuAccountBeneficiaries", new SelectCuAccountBeneficiaries());
}